// @ts-ignore not typed
export const listen = (element, eventType, handler) => {
  if (Array.isArray(eventType)) {
    eventType.forEach((event) => attach(element, event, handler));
  } else {
    attach(element, eventType, handler);
  }
};

// @ts-ignore not typed
const attach = (element, event, handler) =>
  element.addEventListener(event, handler);
